module.exports = __webpack_public_path__ + "img/stock0.c827df05.png";